export default "__VITE_ASSET__a458c65d__"